'use client';
import cn from 'classnames';
import Text from '@/components/common/Text/Text';
import LineDivider from '@/components/common/LineDivider/LineDivider';

import './HalfGridFeature.style.scss';

export type HalfGridFeatureItem = {
  text: string;
  headline: string;
};

export type HalfGridFeatureProps = {
  className?: string;
  items: HalfGridFeatureItem[];
  showBottomLineDivider?: boolean;
};

function HalfGridFeature(props: HalfGridFeatureProps) {
  const { className = '', items, showBottomLineDivider = true } = props;

  // Only take 2 items
  const slicedItems = items?.slice(0, 2);

  return (
    <div className={cn('HalfGridFeature', className)}>
      <div className='item-flex-container'>
        {slicedItems.map((item, index) => {
          return (
            <div
              className='HalfGridFeature-item-container'
              key={index}
            >
              <Text
                className='HalfGridFeature-item-headline'
                variant='title-xxs-500'
                uppercase
              >
                {item.headline}
              </Text>
              <Text
                className='HalfGridFeature-item-text'
                variant='text-s'
              >
                {item.text}
              </Text>
            </div>
          );
        })}
      </div>
      {showBottomLineDivider && (
        <LineDivider className='HalfGridFeature-LineDivider-bottom' />
      )}
    </div>
  );
}

export default HalfGridFeature;
